import styled from 'styled-components';

const StyledMediaRowContainer = styled.div`
  padding: 8px 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.bg.tertiary};
`;

export default StyledMediaRowContainer;
